import React, { useEffect, useState } from "react";
import { reduxForm, Field } from "redux-form";
import { Grid, Header, Divider, Button } from "semantic-ui-react";
import {
  renderTextField,
  renderOptionField,
  renderTextAreaField,
  renderOptionFreeField
} from "../formcomponents";
import ImageFileUploadFileId from "../formcomponents/ImageFileUploadFileId";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice , ImageUrl} from "../formcomponents/Constants";
import { useNavigate, useParams } from "react-router-dom";
import { userData } from "../store/userData";
import Swal from "sweetalert2";
const validate = (values) => {
  const errors = {};
  if (!values.visaCategory) {
    errors.workCvisaCategoryategory = "Required";
  }

  return errors;
};

const DeDailyEntryCreate = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const navigate = useNavigate();
 const { id, catId } = useParams();
  const userDetail = userData();
  const [buttonDisable, setbuttonDisable] = useState(false);

  const[fileUrl, setFileUrl] = useState("")

  const [bankDataList, setBankDataList] = useState([]);
  const [companyDataList, setCompanyDataList] = useState([]);
  const [ticketDataList, setTicketDataList] = useState([]);
  useEffect(() => {
    getDeCompanyList();
    getDeBankList();
    getTicketList();

    props.initialize({
      entryDate: new Date().toISOString().split("T")[0], // Set current date
    });

    if (id !== "null") {
      getWorkList();
    }
  }, []);

  const getDeCompanyList = async () => {
    try {
      const res = await axios.get(BaseUrlInvoice + "/accounts/getCompanyNameList");

      console.log("comp[any List", res.data);
      const processData = res.data?.map((item) => ({
        text: item.name,
        value: item.name,
      }));
      console.log("comp[any List", processData);
      setCompanyDataList(processData);
    } catch (error) {
      console.log(error);
    }
  };

  const getDeBankList = async () => {
    try {
      const res = await axios.post(BaseUrl + "listSSVisaCategory", {
        visaTypeNumber: 42569,
      });
      console.log("Bank List", res.data);
      const processData = res.data?.map((item) => ({
        text: item.visaCategory,
        value: item.visaCategoryId,
      }));
      setBankDataList(processData);
    } catch (error) {
      console.log(error);
    }
  };

  const getTicketList = async () => {
    try {
      const res = await axios.post(BaseUrl + "listSSVisaCategory", {
        visaTypeNumber: 56982,
      });
      console.log("Ticket List", res.data);
      const processData = res.data?.map((item) => ({
        text: item.visaCategory,
        value: item.visaCategoryId,
      }));
      setTicketDataList(processData);
    } catch (error) {
      console.log(error);
    }
  };
  const getWorkList = () => {
    axios
      .post(BaseUrlInvoice + "accounts/getDailyEntry", {
        dailyEntryId: id,
      })
      .then((res) => {
        console.log("res", res.data);
        const tempData = res.data;

        console.log("filterData", tempData);

        initilizeData(tempData);
      })
      .catch((error) => console.log(error));
  };

  const initilizeData = (tempData) => {
    props.initialize({
      ...tempData,
    });
    setFileUrl(tempData?.fileUpload)
  };
  const sumbitForm = async (values) => {
    console.log(values);
    const postObject = {
      ...values,
    };

    console.log("iadbyiagdbygasd", postObject);
    console.log(JSON.stringify(postObject, null, 2));

    await axios
      .post(BaseUrlInvoice + "accounts/createDailyEntry", postObject)
      .then((res) => {
        console.log("res", res.data);
        if (res.data.errorCode === 200) {
          Swal.fire({
            icon: "success",
            title: "sccess",
            text: "Created",
          });
          navigate(-1);
        } else if (res.data.errCode === 283) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "This Work Type Already Created",
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        if (error.response.status === "500") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Data Not Created",
          });
        }
      });
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Create Data Entry
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <Grid columns="five">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="entryDate"
                label="Entry Date"
                type="date"
                component={renderTextField}
              />
            </Grid.Column>
            {/* <Grid.Column>
              <Field
                name="companyNameId"
                label="company Name"
                options={companyDataList}
                component={renderOptionField}
              />
            </Grid.Column> */}
            <Grid.Column>
              <Field
                name="companyName"
                label="company Name"
                options={companyDataList}
                component={renderOptionFreeField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="ticketType"
                label="Ticket Type"
                options={ticketDataList}
                component={renderOptionField}
              />
            </Grid.Column>

            <Grid.Column>
              <Field
                name="paymentRecievedBank"
                label="recived Bank"
                options={bankDataList}
                component={renderOptionField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="amount"
                label="Amount"
                type="number"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              <Field
                name="remarks"
                label="Remarks"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="description"
                label="Description"
                component={renderTextAreaField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="fileUpload"
                label="File"
                component={ImageFileUploadFileId}
              />
                   {fileUrl && (
                <p
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    window.open(
                      ImageUrl + fileUrl,
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                >
                  Download
                </p>
              )}
            </Grid.Column>

            <Grid.Column></Grid.Column>
            <Grid.Column></Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Divider hidden />
      <>
        {" "}
        <Button
          floated="right"
          positive
          disabled={buttonDisable}
          onClick={handleSubmit((values) =>
            sumbitForm({
              ...values,
              categoryId:catId
            })
          )}
        >
          Save
        </Button>
        <Button
          floated="right"
          negative
          disabled={pristine || submitting}
          onClick={reset}
        >
          Cancel
        </Button>{" "}
      </>
    </div>
  );
};

export default reduxForm({
  form: "DeDailyEntryCreate",
})(DeDailyEntryCreate);
